import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import FormikTextInput from 'components/forms/formik/FormikTextInput/FormikTextInput';

export interface TextQuestionProps {
  disabled?: boolean;
  name: string;
}

const TextQuestion: FC<TextQuestionProps> = ({ disabled, name }) => {
  const { t } = useTranslation();

  return (
    <FormikTextInput
      name={name}
      noLabel
      variant="filled"
      placeholder={t('common.form.textPlaceholder')}
      disabled={disabled}
    />
  );
};

export default TextQuestion;
